module.exports = __webpack_public_path__ + "static/media/B.1e3665a6.jpg";